"use client";

import { cn } from "@/src/shared/utils/mergeTwClasses";
import { IconButton, List, ListItem } from "@mui/material";
import { FC } from "react";
import { WebShopIcon } from "../../WebShopIcon";
import {HeaderActionProps, HeaderActionsMenuProps} from "../lib/type";
import { ContactAction } from "./ContactAction";
import { LetterAction } from "./LetterAction";
import { ViberAction } from "./ViberAction";
import { useHeaderCloseBtnStore } from "@/src/stores/useHeaderActions";
import {useAnalytics} from "@/src/components/pages/StepPage/components/useAnalytics";

export const HeaderActionsMenu: FC<HeaderActionsMenuProps> = ({
  actions,
  contacts,
}) => {
  const { isVisible, hideHeaderCloseBtn } = useHeaderCloseBtnStore();

  return (
    <>
      <IconButton
        className={cn("hidden", { "max-md:flex": isVisible })}
        onClick={hideHeaderCloseBtn}
      >
        <WebShopIcon name={"close"} className="fill-blue" />
      </IconButton>
      <List
        className={cn(
          "gap-3 flex-center-row max-md:gap-4 [&>*]:md:shadow-header-buttons",
          {
            "max-md:hidden": isVisible,
          },
        )}
      >
        {actions.map((action) => {
          if (action.method === "viber") {
            return (
              <ListItem key={action.name} className="order-1">
                <ViberAction href="/viber" {...action} />
              </ListItem>
            );
          }
          if (action.method === "contacts") {
            return (
              <ListItem key={action.name} className="order-2 md:order-3">
                <ContactAction {...action} contacts={contacts} />
              </ListItem>
            );
          }

          if (action.method === "letter") {
            return (
              <ListItem key={action.name} className="order-3 md:order-2">
                <LetterAction {...action} />
              </ListItem>
            );
          }
          return null;
        })}
      </List>
    </>
  );
};
